import { combineReducers } from 'redux';

import {
  getScenesListRequest,
  getScenesListSuccess,
  getScenesListFail,
  setScenesDirty,
  createScenesRequest,
  createScenesSuccess,
  deleteScenesRequest,
  deleteScenesSuccess,
  deleteScenesFail,
  saveScenesSuccess,
  updateScenesList,
  clearSceneList,
  getScenesSuccess,
  getScenesListRefreshSuccess,
  setRefreshScenesList,
} from '../actions';
import { ScenesAction } from '../types';
import { Loadable, Reducer } from '../../../types';
import { ItemList } from '../../../../types/main';
import { Scenes } from '../../../../types/items';
import {
  addItemToState,
  removeItemByState,
  updateItemByState,
  updateItemListByState,
  sortState,
} from '../../../util';
import { stripItems } from '../../../../utility/store';

/* eslint-disable no-nested-ternary, no-case-declarations */

type State = Loadable<ItemList<Scenes>>;

type ReducerOf<T extends keyof State> = Reducer<State, ScenesAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getScenesListRequest.type:
      return state ? stripItems(state) : null;

    case getScenesListSuccess.type:
    case getScenesListRefreshSuccess.type:
      return sortState(action.payload, { field: 'title', rule: 'asc' });

    case createScenesSuccess.type:
      return sortState(
        addItemToState(state, action.payload, 'end'),
        { field: 'title', rule: 'asc' },
      );

    case saveScenesSuccess.type:
    case getScenesSuccess.type:
      return updateItemByState(state, action.payload);

    case deleteScenesSuccess.type:
      return removeItemByState(state, action.payload);

    case updateScenesList.type:
      return updateItemListByState(state, action.payload);

    case clearSceneList.type:
      return null;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getScenesListRequest.type:
    case createScenesRequest.type:
    case deleteScenesRequest.type:
      return true;

    case getScenesListSuccess.type:
    case createScenesSuccess.type:
    case getScenesListFail.type:
    case deleteScenesSuccess.type:
    case deleteScenesFail.type:
      return false;

    default:
      return state;
  }
};

const dirty: ReducerOf<'dirty'> = (state = false, action) => {
  switch (action.type) {
    case setScenesDirty.type:
      return action.payload;

    case getScenesListSuccess.type:
    case getScenesListFail.type:
      return false;

    default:
      return state;
  }
};

const refresh: ReducerOf<'refresh'> = (state = false, action) => {
  switch (action.type) {
    case setRefreshScenesList.type:
      return action.payload;

    default:
      return state;
  }
};

export default combineReducers<State>({
  data,
  loading,
  dirty,
  refresh,
});
